export default __webpack_public_path__ + "static/media/m_guide_bg_top.2531edef.png";